import HeroBlock from './HeroBlock'

export default HeroBlock
